// === Message Type Identifiers ===

// Type 0: Initial handshake request (e.g., invitation to start a conversation)
export const MESSAGE_TYPE_HANDSHAKE_REQUEST = 0

// Type 1: Handshake confirmation (e.g., accepting an invite)
export const MESSAGE_TYPE_HANDSHAKE_CONFIRM = 1

// Type 2: Standard text message (regular user message)
export const MESSAGE_TYPE_TEXT = 2

// === Limits ===

// Maximum number of bytes allowed in the message body of an invitation
// This is typically a short introductory message shown during onboarding
export const INVITE_MAX_MESSAGE_LENGTH = 100

export const INVITE_MESSAGE_LENGTH_PREFIX_BYTES = 1;